// import at from "./img/church.png";
import at2 from "./img/church2.png";
import wv from "./img/webvideo3.mp4";
import lg from "./img/LOGO.png";
import tw from "./img/Twitter.png";
import is from "./img/Instagram.png";
import fb from "./img/Facebook.png";
import "./Main.scss";
import News from "./1.News/News";
import Disc from "./2.Disc/Disc";
import Contact from "./3.Contact/Contact";
import Footer from "./4.Footer/Footer";
import Spotify from "./Spotify";
import Burger from "./Burger";
import Video from "./0.VIDEO/Video";
import Toptopic from "./Toptopic";
import { animateScroll as scroll } from "react-scroll";
import totopIcon from "./img/to-top.png";

// import Index from "./5.Index/Index";
import tocbot from "tocbot";
import { useRef,useEffect } from "react";
import "../../node_modules/tocbot/src/scss/tocbot.scss";

const Main = () => {
  useEffect(() => {
    tocbot.init({
      tocSelector: ".toc",
      contentSelector: ".main",
      headingSelector: ".index",
    });
    return () => tocbot.destroy();
  }, []);

  const uptop = () => {
    scroll.scrollToTop();
  };

  const videoRef = useRef(null);

console.log(videoRef.current);
useEffect(() => {
  videoRef.current?.play();
}, []);


  const snsItem = [
    {
      name: "twitter",
      img: tw,
      url: "https://twitter.com/cha_hashi",
    },
    {
      name: "instagram",
      img: is,
      url: "https://www.instagram.com/church.hashimoto/",
    },
    {
      name: "facebook",
      img: fb,
      url: "https://www.facebook.com/profile.php?id=100046501539339",
    },
  ];
  const menuItem = [
    {
      name: "Video",
      url: "#Video",
    },
    {
      name: "Live",
      url: "#Live",
    },
    {
      name: "Disc",
      url: "#Disc",
    },
    {
      name: "Contact",
      url: "#Contact",
    },
  ];
  const menuItem2 = [
    {
      name: "Lyric",
      url: "https://note.com/cha_hashi/m/mfe4ab271be3b",
    },
    {
      name: "Store",
      url: "https://chahashi922.kawaiishop.jp/",
    },
  ];


  return (
    <div className="main">
      {/* ヘッダー */}
      <div className="header">
        <img id="header-image" src={at2} alt="1" />

        <video
          id="header-video"
          ref={videoRef}
          muted
          autoplay
          loop
          playsinline
          src={wv}
          type="video/mp4"
        ></video>

        <div className="Burger-menu">
          <Burger />
        </div>

        <div className="Toptopic">
          <Toptopic />
        </div>

        <div className="menu-bar">
          <div className="menu-container">
            <div className="menu-item">
              <ul>
                {menuItem.map((menuItem) => (
                  <li>
                    <a href={menuItem.url}>
                      <h3>{menuItem.name}</h3>
                    </a>
                  </li>
                ))}
                
              </ul>
            </div>
            <div className="top-menu-logo">
              <a href="/">
                <img src={lg} alt="" />
              </a>
            </div>
            <div className="menu-item2">
              <ul>
                {menuItem2.map((menuItem2) => (
                  <li>
                    <a href={menuItem2.url} target="_blank">
                      <h3>{menuItem2.name}</h3>
                    </a>
                  </li>
                ))}
                
              </ul>
            </div>
            <div className="menu-sns">
              <ul>
                {snsItem.map((snsItem) => (
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={snsItem.url}
                    >
                      <img src={snsItem.img} alt=""></img>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* ヘッダー */}
      <div className="main-container">
        <div className="main-container-index">
          <div className="side-container">
            <h3 className="toc" />
            <Spotify />
          </div>
        </div>

        <div id="culum" className="main-container-item">
          <div className="main-tablet-container">
            <div className="tablet-item">
              <Spotify />
            </div>
          </div>
          <Video />
          <News />
          <Disc />
          <Contact />
        </div>
      </div>
      <div className="toTop">
        <img src={totopIcon} onClick={uptop} />
      </div>
      <div className="Footer">
        <Footer />
      </div>
    </div>
  );
};

export default Main;
